const Footer = () => (
  <footer className="site-footer">
    <div>
      <p>ॐ सर्वे भवन्तु सुखिनः</p>
      <span className="caption">May all be fulfilled.</span>
    </div>
    <div className="footer-contact">
      <p>आर्य समाज मंदिर, गौशाला रोड, अबोहर</p>
      <span className="caption">Arya Samaj Mandir, Gaushala Road, Abohar</span>
      <p>फोन: +91 79861 91357</p>
      <span className="caption">Phone</span>
    </div>
    <div className="footer-note">
      <p>© {new Date().getFullYear()} आर्य समाज अबोहर</p>
      <span className="caption">
        © {new Date().getFullYear()} Arya Samaj Abohar
      </span>
    </div>
  </footer>
);

export default Footer;
